import React, { Component } from 'react';
import './dashboard.css'
import   SideNav from "./../../component/sidenav/sidenav.js"
import  Moble from "./../../component/sidenav/moble.js"
import   ListPayment from "./listpayment.js"
import   Tuition from "./tuitionlist.js"
import  Notices from "./notices.js"
import { Link ,   Redirect} from 'react-router-dom'
import  AuthService  from "../api/authentication.js";
import TimeAgo from 'react-timeago'
import date from 'date-and-time';
import Moment from 'react-moment'
import Navbar from "./../../component/header/header.js"
import { ItemValue } from 'survey-react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Auth = new AuthService();
// https://uvune-events.herokuapp.com
class  Dashboard extends Component {
  constructor(props){
    super(props)
    this.state ={
      user :[],
      tuitions:[],
      news:[],
      image:"",
      disableLink : false,
      noerorrpage :  true,
      transactions : [],
      clickShow : false,
      getData:null,
      editData:null,
      data : [],
      Fmdata : [],
      Tkdata :  [],
      Fmtotal : "",
      TKtotal : "",
      domain: 'https://exam-end.herokuapp.com', 
      localApi:'http://localhost:4000',  
      clsss:[],
      school:null,
      classes:[],
      students:[],
      messageCount:[],
      notice :"false",
      noticeMassage : "",
      isActive : false ,
      loadingnews:false,
      products : [],
      productsCount:"",
      loadProd:true,
      modal:false,
      setPick:null,
      studentModal:false,
      showPage:false,
      selectUnit:"",
      deleteModal:false,
      DeleteData:null,
      studentsCount:null
    }
  }

  componentWillReceiveProps(nextProps) {

    if (nextProps.organizer) {
   
      this.setState({
       
        organizer: nextProps.organizer,
      });

      this.getmessage(nextProps.organizer._id);
    }
  }

  componentDidMount(){
    // console.log("dash users=====================", this.props.user)
   
      this.setState({
        loadingTuition :true,
        isActive:true,
      })
      const requestOptions = {
        method: 'GET', 
        headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*' ,'Authorization': Auth.getToken()  },
    };
 fetch(this.state.domain+"/class/school/"+Auth.getProfile().id, requestOptions )
    .then(res => res.json())
    .then((res)=>{
   
        if(res){
          if(res.status === true){
            console.log("data class", res)
            this.setState({
                loanData : false,
                loadingnews :true,
                classes:res.data,
                classCount:res.data.length,
            })
          }else{
            this.setState({
                loadingnews :false,
                loanData : true
            })
             this.timeout()
          }
            // console.log("res notice",res, res.data)
           
        }else{
            this.setState({
                loadingnews  :false
            }) 
        }
    })
 fetch(this.state.domain+"/school/"+Auth.getProfile().id, requestOptions )
    .then(res => res.json())
    .then((res)=>{
    
        if(res){
          if(res.status === true){
            console.log("data notices", res)
            this.setState({
                school:res.data,
                loanData : false,
                loadingnews :true,
                students:res.data.students
            })
          }else{
            this.setState({
                loadingnews :false,
          
                
                loanData : true
            })
             this.timeout()
          }
            // console.log("res notice",res, res.data)
           
        }else{
            this.setState({
                loadingnews  :false
            }) 
        }
    })
    fetch(this.state.domain+"/students/school/"+Auth.getProfile().id, requestOptions )
    .then(res => res.json())
    .then((res)=>{
    
        if(res){
          if(res.status === true){
            console.log("data notices", res)
            this.setState({
               
                loanData : false,
                loadingnews :true,
                studentsCount:res
            })
          }else{
            this.setState({
                loadingnews :false,
          
                
                loanData : true
            })
             this.timeout()
          }
            // console.log("res notice",res, res.data)
           
        }else{
            this.setState({
                loadingnews  :false
            }) 
        }
    })


  }
  
  getmessage=(data)=>{
    
//   const requestOptions = {
//       method: 'GET', 
//       headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*' ,'Authorization': Auth.getToken()  },
//   };
//   return fetch(this.state.localApi+"/school/"+Auth.getProfile().id, requestOptions )
//   .then(res => res.json())
//   .then((res)=>{
//       console.log("data notices", res)
//       if(res){
//         if(res.status === true){
//           this.setState({
            
//               loanData : true,
//               loadingnews :false,
//           })
//         }else{
//           this.setState({
//               loadingnews :false,
//               messages:res.data,
//               messageCount:res.data.length,
//               loanData : true
//           })
//            this.timeout()
//         }
//           // console.log("res notice",res, res.data)
         
//       }else{
//           this.setState({
//               loadingnews  :false
//           }) 
//       }
//   })



 
}
  closenotice=(e)=>{
      e.preventDefault()
      this.setState({
        notice :false
      })
  }





    checkUsers = ()=>{
        if(!this.props.user.fullname === "" && !this.props.user.address === ""  &&  !this.props.user.about === ""
        && !this.props.user.account_no === "" 
         && !this.props.user.phone_one ==="" && !this.props.user.phone_two === "" ){
             this.setState({
               submitIftrue : true,
             })
           return true
       }else{
           this.setState({
               submitIftrue : false
             })
           return  false
       }
      }

      clickIfShow=(data)=>{
          
        this.setState({
            data : data ,
            clickShow : true
        })
        
    }

    
   timeout() {
    setTimeout(function() {
        this.setState({
            noticespop : false,
            // ifRead:true,
            loadingnews:true,
            loanData:false
        })
    //   console.log("data  loanData---===>", this.state.loadData);
    }.bind(this), 4000);
}


    
      

  logout = () =>{
   
    this.props.logout()
  }

  openModel = () =>{

  }
  

  closeModal = () =>{
    console.log("data-FALSE---student")
    this.setState({
        modal:false,
        studentModal:false,
        getData:null,
        deleteModal:false
    })
  }

  AddStudent =(data)=>{
      console.log("data----student",data)
      this.setState({
          modal:true,
          getData:data
      })
  }

 handleTerm = (e) => { 
    this.setState({
        setPick:e.target.value
    })  
 }

 showStudent=(data)=>{
    console.log("get all student===----->", data)
  this.setState({
    studentModal:true,
    getData:data,
    selectUnit:data._id
   })  
 }

 AddStudentInClass = (e)=>{
    e.preventDefault()
    // console.log("data update===----->", this.state.select)
    this.setState({
      loanData:true
    })
     const data = {
        firstName: this.lastName.value,
        lastName :this.firstName.value,
        getClass :this.classId.value,
        schoolId:this.state.school._id,
        gender:this.state.setPick,
     }
     console.log("data-------------->",data)
     const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    };
     fetch(this.state.domain+`/students`, requestOptions)
               .then(res => res.json())
               .then((res)=>{
                   if(res){
                      console.log("result---===========----->", res)
                    
                      for (const obj of this.state.classes) {
                        console.log("data----------first----student>","id am getting==-->",this.state.getData._id,obj._id)
                        if (obj._id === this.state.getData._id) {
                          console.log("data--------------student>","id am getting==-->",this.state.getData._id,obj._id)
                            obj.students.push(res.data)
                           
                          break;
                        }
                      }
                      // const classes = this.state.getData
                      
                      console.log("checking---===========----->",this.state.classes)
                      const students =   this.state.students
                      students.push(res.data)
                      toast("Created !");
                       this.setState({
                           
                        modal:false,
                            students:students,
                           loading:false,
                           loanData:false
                       })
                   }
                 
               }).catch( (error) => {
                
          })
 }




 EditStudentInClass=(e)=>{
  e.preventDefault()
  console.log("data update===----->", )
  this.setState({
    loanData:true
  })
   const data = {
      firstName: this.lastName.value,
      lastName :this.firstName.value,
      getClass :this.state.selectUnit,
      schoolId:this.state.school._id,
      gender:this.state.setPick,
      from:this.state.editData._id
   }
   console.log("data-------------->",data)
  const requestOptions = {
    method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
  };
   fetch(this.state.domain+`/students/`+this.state.editData._id, requestOptions)
             .then(res => res.json())
             .then((res)=>{
                 if(res){
                    console.log("result-------->", res)
                    toast("Created !");
                     this.setState({
                         loading:false,
                         loanData:false,
                         studentModal:false
                     })
                     
                    //  this.props.history.replace('/dashboard');
                 }
               
             }).catch( (error) => {
              
        })
 }

 DeleteMethod=(data)=>{

  const requestOptions = {
    method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
  };
   fetch(this.state.domain+`/students/`+this.state.DeleteData._id, requestOptions)
             .then(res => res.json())
             .then((res)=>{
                 if(res){
                    console.log("result-------->", res)
                    toast("Created !");
                     this.setState({
                         loading:false,
                         loanData:false,
                         deleteModal:false
                     })
                     
                    //  this.props.history.replace('/dashboard');
                 }
               
             }).catch( (error) => {
              
        })
 }

 showEdit=(data)=>{
  console.log("data--===------> show student data", data)
  this.setState({
   showPage:true,
   editData:data,
   setPick:data.gender
  })
 }

 Unitselect = (e) =>{
  console.log("data--===------> selectcurrency", e.target.value)
  this.setState({
    // ifCatalog:true,
    selectUnit: e.target.value
})
}

showDelete = (data) =>{
  this.setState({
    deleteModal:true,
    DeleteData:data,
  })

}


  render() {

      //  console.log("cheking users---------", this.props.user, "state", this.props.organizer, this.props.organizers404)
    return (
        !this.props.isAuthenticated ? (
        
           <Redirect to={{    pathname: `${'/login'}`  }}/>
                ) : (
            <div >


         {/* <Navbar   logout={this.logout} />   */}
          
           <div id="" class="columns dashboard-cousom">
           <ToastContainer />
            <div class="column"></div>
            <div class="content column is-11">
        
                {/* <!-- Breadcrumbs --> */}
                <nav class="breadcrumbs">
                    {/* <button onClick={this.clickeme}>click</button> */}
                    <ul>
                        <li><a href="/">Home</a></li>
                        <li>Dashboard</li>
                    </ul>
                </nav>
                {/* <!-- /Breadcrumbs -->
        
                <!-- Dashboard Wrapper --> */}
                <div class="dashboard-wrapper dashboard-wrapper-dacktop">
        
                    <div class="columns">           
                        <div class="column">
                            {/* <!-- Main content --> */}
                            <div id="main-dashboard" class="section-wrapper">
                              
                                {/* <!-- Stat tiles --> */}
                                <div class="columns dashboard-columns">
                                <div class="column is-5">
                                 
                                           
                                        
                                            {
                                              this.state.school == null?
                                              <div></div>
                                              :
                                              <div className="show-info">
                                                  
                                                      <h2><b>Name :</b> {this.state.school.name}</h2>
                                                      <h2><b>Address :</b> {this.state.school.address}</h2>
                                                      <h2><b>Phone :</b> {this.state.school.phoneNumber}</h2>
                                                    
                                                      
                                                      {/* <h2><b> :</b> school name</h2> */}
                                                  
                                              </div>
                                            }
                                        
                                      
                                    </div>

                                    {/* <!-- Tile --> */}
                                    <div class="column is-3">
                                        <div class="flex-card card-overflow light-bordered light-raised">
                                            <div class="icon-header">
                                                <i class="material-icons primary">layers</i>
                                            </div>
                                            <div class="content">
                                                <div class="card-title is-tile has-text-right">
                                                {
                                                    this.state.school == null?
                                                    <small style={{fontSize:"75%"}}>
                                                    New Students
                                                    </small> 
                                                    :
                                                    <small style={{fontSize:"75%"}}>
                                                       New Students { this.state.school.students.length}
                                                    </small> 
                                                }
                                                
                                                    <div class="card-stat primary has-text-right">{this.state.productsCount} <span class="stat-type">
                                                        {/* this month */}
                                                        </span></div>
                                                </div>
                                            </div>
                                            <div class="more">
                                                <a class="primary" href="/products">See all</a>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    
                                    {/* <!-- Tile --> */}
                                    <div class="column is-3">
                                        <div class="flex-card card-overflow light-bordered light-raised">
                                            <div class="icon-header">
                                                <i class="material-icons primary">school</i>
                                            </div>
                                            <div class="content">
                                                <div class="card-title is-tile has-text-right">
                                                {
                                                  this.state.studentsCount === null?
                                                <small style={{fontSize:"75%"}}>Total student </small>  
                                                :
                                                // eslint-disable-next-line no-sequences
                                                <small style={{fontSize:"75%"}}>Total student {" ",this.state.studentsCount.total} </small> 
                                                }
                                                {
                                                  this.state.studentsCount === null?
                                                  <div class="card-stat primary has-text-right">
                                                    <span class="stat-type"></span>
                                                        
                                                        
                                                    </div>
                                                    :
                                                    <div class="card-stat primary has-text-right">
                                                    <span class="stat-type"></span>
                                                  
                                                        
                                                    </div>
                                                } 
                                                    
                                                </div>
                                            </div>
                                            <div class="more">
                                                <a class="primary" href="/messages">Open</a>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <!-- Tile --> */}
                                    {/* <div class="column is-3">
                                        <div class="flex-card card-overflow light-bordered light-raised">
                                            <div class="icon-header">
                                                <i class="material-icons primary">contacts</i>
                                            </div>
                                            <div class="content">
                                                <div class="card-title is-tile has-text-right">
                                                   Contacts
                                                    <div class="card-stat primary has-text-right">14 <span class="stat-type">
                                                      
                                                        </span></div>
                                                </div>
                                            </div>
                                            <div class="more">
                                                <a class="secondary" href="#">See all</a>
                                            </div>
                                        </div>
                                    </div> */}
                                    {/* <!-- Tile --> */}
                                    {/* <div class="column is-3">
                                        <div class="flex-card card-overflow light-bordered light-raised">
                                            <div class="icon-header">
                                                <i class="material-icons primary">call</i>
                                            </div>
                                            <div class="content">
                                                <div class="card-title is-tile has-text-right">
                                                    Leads
                                                    <div class="card-stat primary has-text-right">53 <span class="stat-type">new leads</span></div>
                                                </div>
                                            </div>
                                            <div class="more">
                                                <a class="secondary" href="#">See all</a>
                                            </div>
                                        </div>
                                    </div> */}
                                </div>
                                
                               
                                  <div >
                                    <div class="columns">
                                        <div class="column is-half">
                                        <div class="pills-widget flex-card light-bordered light-raised">
                                            <div class="navigation-tabs full-pills primary animated-tabs">
                                            <div class="material-header is-primary has-text-centered" style={{background:"#00D1B2" }}>
                                                <h3>New Student</h3>
                                        
                                            </div>
                                            {
                                              this.state.loadingnews?
                                                <div id="tasks" class="navtab-content is-active">
                                                {
                                                  this.state.school?
                                                  <div>
                                                   {
                                                      this.state.students.length  === 0 ?
                                                       <div>
                                                           <div style={{textAlign:"center"}}>
                                                          
                                                                <i class="sl sl-icon-social-dropbox heard-icon-side" style={{fontSize:"300%"}}></i>
                                                                                     <p>No Student</p>
                                                          </div>
                                                       </div>
                                                       :
                                                        <ol class="task-list">
                                                          
                                          
                                                            {
                                                                  this.state.students.map((itam, i)=>{
                                                                        return(

                                                                            <li class="is-active" key={itam._id}>
                                                                                    <div className="class-body">
                                                                                    <div className='class-name'>{itam.firstname} { " " } { " " } {itam.lastname}</div>
                                                                                    
                                                                                       
                                                                                    <div className='class-other'>{itam.gender}</div>
                                                                                
                                                                                    <div className='class-other'>{itam.class.name}</div>
                                                                                    
                                                                                    <div className='class-bottom'>
                                                                                    
                                                                                    </div>
                                                                                    </div>
                                                                                </li>

                                                                        )
                                                                  })     
                                                            }              
                                                          
                                                        
                                                        </ol>
                                                      
                                                      }
                                                    </div>
                                                    :
                                                    <div></div>
                                                  }
                                                </div>
                                                :
                                                <div>
                                                     <div style={{textAlign:"center", marginBottom:"10px", marginTop:"10px"}}>
                                                        <a class="button is-loading">Loading</a>
                                                     </div>
                                                </div>
                                              }
                                            </div>
                                        </div>
                                        </div>
                                        <div class="column">
                                        <div class="pills-widget flex-card light-bordered light-raised">
                                            <div class="navigation-tabs full-pills primary animated-tabs">
                                            <h3 class="card-heading has-icon">All Classes  </h3>
                                                {/* <div class="tabs is-centered">
                                                    <ul>
                                                        <li class="tab-link is-active" data-tab="messages"><a>Messages</a></li>
                                                        
                                                     
                                                    </ul>
                                                </div> */}
                                            {
                                              this.state.loadingnews?
                                                <div id="tasks" class="navtab-content is-active">
                                                {
                                                    this.state.classes?
                                                     <div>
                                                         {
                                                          this.state.classes.length  === 0 ?
                                                          <div style={{textAlign:"center"}}>
                                                                <i class="material-icons primary" style={{fontSize:"300%"}}>sms</i>
                                                                                     <p>No message</p>
                                                          </div>
                                                          :
                                                            <ul class="messages-list">
                                                                {
                                                                  this.state.classes.map((itam, i)=>{
                                                                        return(
                                                                            
                                                                               <li class="is-active" key={itam._id}>
                                                                                    <div className="class-body moblie-vide-class">
                                                                                     <div className='class-name moblie-class-name'>{itam.name}</div>
                                                                                     {
                                                                                        itam.students === null || itam.students === undefined ?
                                                                                        <div className='class-other moblie-class-other '>0</div>
                                                                                        :
                                                                                        <div className='class-other moblie-class-other'>{itam.students.length}</div>
                                                                                     }
                                                                                    
                                                                                     
                                                                                     <div className='class-bottom'>
                                                                                        <a class="button is-small btn-align accent-btn raised rounded btn-outlined is-rounded" 
                                                                                        onClick={(e)=>this.AddStudent(itam)}
                                                                                        >Add Student</a>
                                                                                        <a  style={{marginLeft:'10%'}}  class="button is-small is-primary is-rounded" 
                                                                                        onClick={(e)=>this.showStudent(itam)}
                                                                                        >Open</a>
                                                                                     </div>
                                                                                    </div>
                                                                                </li>
                                                 
                                                                                )
                                                                             })
                                                                        } 
                                                            
                                                            </ul>
                                                          
                                                         }
                                                     </div>
                                                     :
                                                     <div>
                                                       
                                                     </div>
                                                  }    
                                                </div>
                                                :
                                                <div style={{textAlign:"center", marginBottom:"10px"}}>
                                                  <a class="button is-loading">Loading</a>
                                                </div>
                                              }
                                            </div>
                                        </div>
                                        </div>

                                     </div>
                                    
                                    
                                   
                                  
                                </div>
                                {/* <!-- /Widgets --> */}
                            </div>
                            {/* <!-- /Main content --> */}
                        </div>
                        {/* <!-- /Main view --> */}
                    </div>
                </div>
                {/* <!-- /Dashboard Wrapper --> */}
            </div>
            <div class="column"></div>
        </div>

       {
           this.state.modal?
           <div class="pre-loader">
            <div className="modal is-active  add-student-cost">
                <div className="modal-background" ></div>
             <div className="modal-card">
                <header className="modal-card-head">
                {
                 this.state.getData === null?
                 <p className="modal-card-title">title</p>
                 :
                 <p className="modal-card-title" style={{textTransform:'capitalize'}}>Add Student {" "}{this.state.getData.name}</p>
                }
              
                <button className="delete" aria-label="close" onClick={this.closeModal}></button>
                </header>
                <section className="modal-card-body">
                <form onSubmit={this.AddStudentInClass}>
                 <div class="columns">

                  <div class="column is-one-third">Name :</div>
                    <div class="column">
                        <div class="control">
                            <input class="input is-small" type="text" 
                               ref={ input => this.firstName = input }
                                placeholder="First name"/>
                            </div>
                        </div>
                        <div class="column">
                           <div class="control">
                                <input class="input is-small" type="text" 
                                    ref={ input => this.lastName = input }
                                    placeholder="Last name" required
                                 />
                            </div>
                        </div>
                   </div>
                   {
                    this.state.getData === null?
                    <div></div>
                    :
                    <input class="input is-small" 
                        ref={ input => this.classId = input }
                        defaultValue={this.state.getData._id}
                        type="hidden" 
                        placeholder="Last name" required
                        />
                   }
                   <div class="columns">
                     <div class="column is-one-third">Sex:</div>
                      <div class="column">
                        <div class="field">
                         <div class="control">
                           <div class="select ">
                            <select onChange={this.handleTerm}  class="form-control" value={this.state.pick} >
                                    <option > Sex </option>
                                    <option value={"Male"}>Male</option>
                                    <option value={"Female"}>Female</option>
                               </select>
                            </div>
                            </div>
                          </div>
                       </div>
                    </div>

                   
                    <div className="info-payment-button">
                    {
                        this.state.loanData?
                          <a class="button is-loading">Loading</a>
                        :
                        <button  class="button is-primary is-rounded" >Submit</button>
                    }
                        
                    </div>
                 </form>  
                </section>
                
                </div>
            </div>
            </div>
            :
            <div></div>
         }

         {
          this.state .studentModal?
          <div class="pre-loader">
          <div className="modal is-active  add-student-cost">
            <div className="modal-background" onClick={this.closeModal}></div>
            <div className="modal-card">
              <header className="modal-card-head">
              {
                this.state.getData === null?
                  <p className="modal-card-title" style={{textTransform:'capitalize'}}>All Student From </p>
                :
                  <p className="modal-card-title" style={{textTransform:'capitalize'}}>All Student From {this.state.getData.name}</p>
              }
             
              <button className="delete" aria-label="close" onClick={this.closeModal}></button>
              </header>
              {
                this.state.showPage ?
                <section className="modal-card-body">
                 <form onSubmit={this.EditStudentInClass}>
                      <div class="columns">

                      <div class="column is-one-third">Name :</div>
                        <div class="column">
                            <div class="control">
                                <input class="input is-small" type="text" 
                                    ref={ input => this.firstName = input }
                                    defaultValue={this.state.editData.firstname} 
                                    placeholder="First name"/>
                                </div>
                            </div>
                            <div class="column">
                                <div class="control">
                                    <input class="input is-small" type="text" 
                                        ref={ input => this.lastName = input }
                                        defaultValue={this.state.editData.lastname} 
                                        placeholder="Last name" required 
                                      />
                                </div>
                            </div>
                        </div>
                      
                        <div class="columns">
                          <div class="column ">Gender:</div>
                          <div class="column">
                            <div class="field">
                              <div class="control">
                                <div class="select ">
                                <select onChange={this.handleTerm}  class="form-control" value={this.state.setPick} >
                                      {
                                        this.state.editData === null ||  this.state.editData === undefined ?
                                        null
                                        :
                                        <option value={this.state.editData.gender}>  {this.state.editData.gender}    </option> 
                                        
                                      }
                                     
                                        <option value={"Male"}>Male</option>
                                        <option value={"Female"}>Female</option>
                                    </select>
                                </div>
                                </div>
                              </div>
                            </div>
                            <div class="column ">Class:</div>
                            <div class="column">
                              
                               
                                  <div class="select ">
                                    <select class="form-control" style={{width:"200px"}} onChange={this.Unitselect} value={this.state.selectUnit}>
                                    {
                                      this.state.editData === null ||  this.state.editData === undefined ?
                                      null
                                      :
                                      <option value={this.state.getData._id}>  {this.state.getData.name}    </option> 
                                      
                                    }
                                      
                                      {
                                        this.state.classes.map(data => {
                                              return  <option key={data} value={data._id}>{data.name}</option>
                                          })
                                      }
                                    </select>
                                  </div>
                           
                              
                              </div>
                           
                        </div>

                        
                        <div className="info-payment-button">
                        {
                            this.state.loanData?
                              <a class="button is-loading">Loading</a>
                            :
                            <button  class="button is-primary is-rounded" >Submit</button>
                        }
                            
                        </div>
                      </form>  
                </section>
                :
                 <section className="modal-card-body">
                    {
                      this.state.getData?
                      <ol class="task-list">                                                          
                          {
                            this.state.getData.students.map((itam, i)=>{
                                      return(

                                          <li class="is-active" key={itam._id} style={{marginBottom:'10px'}}>
                                                  <div className="class-body">
                                                  <div className='class-name'>{itam.firstname} { " " } { " " } {itam.lastname}</div>
                                                  
                                                    
                                                  <div className='class-other'>{itam.gender}</div>
                                              
                                                  <div className='class-other'>{itam.class.name}</div>
                                                  
                                                  <div className='class-bottom' >
                                                  <a  style={{marginLeft:'10%'}}  class="button is-small is-primary is-rounded" 
                                                    onClick={(e)=>this.showEdit(itam)}
                                                    >Edit</a>
                                                    <a  style={{marginLeft:'10%'}}  class="button is-small is-danger is-rounded" 
                                                    onClick={(e)=>this.showDelete(itam)}
                                                    >Delele</a>
                                                  </div>
                                                  </div>
                                              </li>

                                      )
                                })     
                          }              
                      </ol>
                      :
                      <div></div>
                    }
                
                </section>
              }
             
           
            </div>
            </div>
          </div>
          :
          <div></div>
        }

    {
      this.state.deleteModal?
      <div class="pre-loader">
      <div className="modal  is-active add-student-cost">
        <div className="modal-background" onClick={this.closeModal}></div>
        <div className="modal-card">
          <header className="modal-card-head">
          {
            this.state.DeleteData === null ||  this.state.DeleteData  === undefined ?
            <p className="modal-card-title">tile</p>
            :
            <p className="modal-card-title">Delete  </p>
          }
          
          <button className="delete" aria-label="close" onClick={this.closeModal}></button>
          </header>
          <section className="modal-card-body" style={{textAlign: 'center'}}>
            {
              this.state.DeleteData === null ||  this.state.DeleteData  === undefined ?
              <p className="modal-card-title">Delete</p>
              :
              <p className="modal-card-title">Are You Sure want To delete<br/> 
              { this.state.DeleteData.firstname}  {'  '}   { this.state.DeleteData.lastname}</p>
            }
            
            {
              this.state.loanData?
                <a class="button is-loading" style={{marginTop:'30px'}}>Loading</a>
              :
              <a  style={{marginLeft:'10%',marginTop:'30px'}}  class="button  is-danger is-rounded" 
              onClick={(e)=>this.DeleteMethod()}
              >Delele</a>
            }
          
          </section>
         
         </div>
        </div>
      </div>
      :
      <div></div>
    }
        

      </div>
       )
    );
  }
}

export default  Dashboard;





// WEBPACK FOOTER //
// ./src/component/dashboard/dashboard.js